module.exports = __webpack_public_path__ + "static/media/focused-marker.ec349253.webp";